// Root Server translations

const rootserver = {
  en: {
    rootserver: {
      title: "KVM Root Servers",
      subtitle: "Full root access, dedicated resources, and DDoS protection. Choose Linux or Windows – PrePaid, no contract.",
      from: "from",
      benefits: "DDoS Protection|PrePaid – No Contract|Full Root Access|NVMe Storage|KVM / VMware|Frankfurt Location",
      configureNow: "Configure Now",
      soldOut: "Sold Out",
      bestSeller: "Best Seller",
      backToAll: "All Root Servers",
      everythingIncluded: "Everything included",
      otherType: "Other Rootserver type:",
      prepaid: "PrePaid",
      noContract: "No Contract",
      viewDedicated: "View Dedicated Servers",
      viewSale: "View Sale Servers",
      ctaTitle: "Need even more power?",
      ctaDesc: "Check out our dedicated servers – exclusive physical hardware, no shared resources.",
      badge_epyc: "AMD Epyc",
      badge_windows: "Windows",
      linux_title: "Linux KVM Rootserver",
      linux_tagline: "AMD Epyc · NVMe SSD · Debian, Ubuntu, CentOS & more",
      linux_desc: "Fast and powerful Linux root servers on AMD Epyc hardware with NVMe storage. Full SSH access, KVM virtualization, and your choice of operating system – online within 60 seconds.",
      linux_meta: "Linux root server on AMD Epyc with NVMe SSD, KVM virtualization and full SSH access. Debian, Ubuntu & more – online in 60 seconds, no contract.",
      linux_hero1: "Your Linux Server.",
      linux_hero2: "Online in 60 seconds.",
      linux_plan1_sub: "The smallest.",
      linux_plan2_sub: "The medium-sized.",
      linux_plan3_sub: "The large.",
      linux_plan4_sub: "The bestseller.",
      linux_plan5_sub: "The gigantic.",
      linux_plan6_sub: "The overkill.",
      linux_feat1: "AMD Epyc CPUs",
      linux_feat1_desc: "Powerful AMD Epyc processors for demanding server workloads.",
      linux_feat2: "NVMe SSD Storage",
      linux_feat2_desc: "Ultra-fast NVMe storage for minimal I/O latency and lightning-fast boot times.",
      linux_feat3: "KVM Virtualization",
      linux_feat3_desc: "Full kernel control – upgrade your kernel or install custom ISO images.",
      linux_feat4: "Many OS Choices",
      linux_feat4_desc: "Debian, Ubuntu, CentOS, and more – one-click installation from ISO.",
      linux_feat5: "TekBase / Pterodactyl",
      linux_feat5_desc: "Game panel software (TekBase & Pterodactyl) optionally available.",
      linux_feat6: "60-Second Setup",
      linux_feat6_desc: "Server is automatically deployed within 60 seconds after payment.",
      windows_title: "Windows Rootserver",
      windows_tagline: "Windows Server 2012 / 2016 / 2019 · RDP included · VMware ESXi",
      windows_desc: "Manage your Windows root server over Remote Desktop – like a normal Windows PC. Windows Server 2012, 2016, or 2019 license is fully included. VMware ESXi virtualization for enterprise-grade stability.",
      windows_meta: "Windows root server with Windows Server 2012/2016/2019 license included, managed via Remote Desktop on VMware ESXi. Prepaid, no contract.",
      windows_hero1: "Windows Server.",
      windows_hero2: "Fully managed via RDP.",
      windows_plan1_sub: "For the small needs.",
      windows_plan2_sub: "For the middle things.",
      windows_plan3_sub: "For the big plans.",
      windows_feat1: "RDP Access",
      windows_feat1_desc: "Connect via Remote Desktop from any Windows PC, macOS, or mobile device.",
      windows_feat2: "Windows License",
      windows_feat2_desc: "Windows Server 2012, 2016, or 2019 fully included – no extra cost.",
      windows_feat3: "VMware ESXi",
      windows_feat3_desc: "Enterprise-grade VMware ESXi virtualization for maximum stability.",
      windows_feat4: "SSD / HDD Choice",
      windows_feat4_desc: "Choose between fast SSD or high-capacity HDD storage.",
      windows_feat5: "Unlimited FairUse",
      windows_feat5_desc: "No hard traffic limit – FairUse keeps costs fair for everyone.",
      windows_feat6: "Setup in 30–60 min",
      windows_feat6_desc: "Server fully configured within 30–60 minutes after payment.",
    },
  },

  de: {
    rootserver: {
      title: "KVM Rootserver",
      subtitle: "Voller Root-Zugriff, dedizierte Ressourcen und DDoS-Schutz. Wähle Linux oder Windows – Prepaid, kein Vertrag.",
      from: "ab",
      benefits: "DDoS-Schutz|Prepaid – kein Vertrag|Voller Root-Zugriff|NVMe-Speicher|KVM / VMware|Standort Frankfurt",
      configureNow: "Konfigurieren",
      soldOut: "Ausverkauft",
      bestSeller: "Bestseller",
      backToAll: "Alle Rootserver",
      everythingIncluded: "Alles inklusive",
      otherType: "Anderer Rootserver-Typ:",
      prepaid: "Prepaid",
      noContract: "Kein Vertrag",
      viewDedicated: "Dedicated Server ansehen",
      viewSale: "Angebots-Server ansehen",
      ctaTitle: "Noch mehr Power gefragt?",
      ctaDesc: "Schau dir unsere Dedicated Server an – exklusive physische Hardware, keine geteilten Ressourcen.",
      badge_epyc: "AMD Epyc",
      badge_windows: "Windows",
      linux_title: "Linux KVM Rootserver",
      linux_tagline: "AMD Epyc · NVMe SSD · Debian, Ubuntu, CentOS & mehr",
      linux_desc: "Schnelle und leistungsstarke Linux-Rootserver auf AMD Epyc-Hardware mit NVMe-Speicher. Voller SSH-Zugriff, KVM-Virtualisierung und freie Wahl des Betriebssystems – innerhalb von 60 Sekunden online.",
      linux_meta: "Linux-Rootserver auf AMD Epyc mit NVMe SSD, KVM-Virtualisierung und vollem SSH-Zugriff. Debian, Ubuntu & mehr – in 60 Sekunden online.",
      linux_hero1: "Dein Linux Server.",
      linux_hero2: "Online in 60 Sekunden.",
      linux_plan1_sub: "Der Kleinste.",
      linux_plan2_sub: "Der Mittelgroße.",
      linux_plan3_sub: "Der Große.",
      linux_plan4_sub: "Der Bestseller.",
      linux_plan5_sub: "Der Riesige.",
      linux_plan6_sub: "Das Overkill.",
      linux_feat1: "AMD Epyc CPUs",
      linux_feat1_desc: "Leistungsstarke AMD Epyc-Prozessoren für anspruchsvolle Server-Workloads.",
      linux_feat2: "NVMe SSD-Speicher",
      linux_feat2_desc: "Ultra-schneller NVMe-Speicher für minimale I/O-Latenz und blitzschnelle Boot-Zeiten.",
      linux_feat3: "KVM-Virtualisierung",
      linux_feat3_desc: "Volle Kernel-Kontrolle – eigenen Kernel aktualisieren oder ISO-Images installieren.",
      linux_feat4: "Viele OS-Optionen",
      linux_feat4_desc: "Debian, Ubuntu, CentOS und mehr – Ein-Klick-Installation per ISO.",
      linux_feat5: "TekBase / Pterodactyl",
      linux_feat5_desc: "Game-Panel-Software (TekBase & Pterodactyl) optional erhältlich.",
      linux_feat6: "60-Sekunden-Setup",
      linux_feat6_desc: "Server wird automatisch innerhalb von 60 Sekunden nach Zahlung bereitgestellt.",
      windows_title: "Windows Rootserver",
      windows_tagline: "Windows Server 2012 / 2016 / 2019 · RDP inklusive · VMware ESXi",
      windows_desc: "Verwalte deinen Windows-Rootserver per Remote Desktop – wie einen normalen Windows-PC. Windows Server 2012, 2016 oder 2019 inklusive. VMware ESXi-Virtualisierung für Enterprise-Stabilität.",
      windows_meta: "Windows-Rootserver inkl. Lizenz für Windows Server 2012/2016/2019, Verwaltung per Remote Desktop auf VMware ESXi. Prepaid, ohne Vertrag.",
      windows_hero1: "Windows Server.",
      windows_hero2: "Vollständig per RDP verwalten.",
      windows_plan1_sub: "Für kleine Anforderungen.",
      windows_plan2_sub: "Für mittlere Anforderungen.",
      windows_plan3_sub: "Für große Pläne.",
      windows_feat1: "RDP-Zugriff",
      windows_feat1_desc: "Verbindung per Remote Desktop von Windows-PC, macOS oder mobilen Geräten.",
      windows_feat2: "Windows-Lizenz",
      windows_feat2_desc: "Windows Server 2012, 2016 oder 2019 vollständig inklusive – kein Aufpreis.",
      windows_feat3: "VMware ESXi",
      windows_feat3_desc: "Enterprise VMware ESXi-Virtualisierung für maximale Stabilität.",
      windows_feat4: "SSD / HDD-Auswahl",
      windows_feat4_desc: "Wähle zwischen schneller SSD oder großkapazitiver HDD-Speicherung.",
      windows_feat5: "Unbegrenzter FairUse",
      windows_feat5_desc: "Kein hartes Traffic-Limit – FairUse hält die Kosten für alle fair.",
      windows_feat6: "Setup in 30–60 Min.",
      windows_feat6_desc: "Server innerhalb von 30–60 Minuten nach Zahlung vollständig konfiguriert.",
    },
  },
};

export default rootserver;
